// import logo from './logo.svg';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { useEffect } from "react";
import { loaduser } from "./actions/auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./auth/Login";
import Register from "./auth/Register";
import store from "./store";
import { Provider } from "react-redux";
import AuthenticatedRoutes from "./routes/authenticatedRoutes";
import setAuthToken from "./utils/setAuthToken";
import Alert from "./components/Alert";
if (localStorage.token) {
  //console.log(localStorage.token)
  setAuthToken(localStorage.token);
}
function App() {
  useEffect(() => {
    //console.log(store.dispatch(loaduser()));
    store.dispatch(loaduser());
  }, []);
  return (
    <div>
      <Provider store={store}>
      <Router>
        <Alert />
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route exact path="/*" element={<AuthenticatedRoutes />} />
        </Routes>
      </Router>
      </Provider>
    </div>
  );
}

export default App;
